import '../pcss/app.pcss';
import 'virtual:svg-icons-register';
import { init as initCookieThough, show as showCookieThough, onPreferencesChanged, getPreferences as getCookiePreferences } from 'cookie-though';
import 'lazysizes';
import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import AlpineFloatingUI from '@awcodes/alpine-floating-ui'
import NotificationsAlpinePlugin from '../../vendor/filament/notifications/resources/js/components/notification.js'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeNl from 'air-datepicker/locale/nl';
import localeFr from 'air-datepicker/locale/fr';
import 'livewire-sortable';
import * as focusTrap from 'focus-trap';
// core version + navigation, pagination modules:
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { set, throttle } from 'lodash';
Swiper.use([Navigation, Pagination, Autoplay]);
// init Swiper:
window.Swiper = Swiper;
import geolocation from './geolocation.js';
import { placesOverview, placeDetail, trackAndTrace } from './places.js';
import { initUploadCompress } from './uploadCompress.js';
Alpine.plugin(AlpineFloatingUI);
Alpine.plugin(NotificationsAlpinePlugin);
Alpine.data('geolocation', geolocation);
window.geolocation = geolocation;
Alpine.data('placesOverview', placesOverview);
Alpine.data('placeDetail', placeDetail);
Alpine.data('trackAndTrace', trackAndTrace);
window.Alpine = Alpine;
window.AirDatepicker = AirDatepicker;
window.AirDatepickerLocaleNL = localeNl;
window.AirDatepickerLocaleFR = localeFr;
window.Livewire = Livewire;
Livewire.start();

initUploadCompress();

initCookieThough(window.cookieconfig);

const hasStatisticsConsent = (preferences) => preferences.cookieOptions.some(
    option => option.id === 'statistics' && option.isEnabled === true
);

// Persist ad consent as a first-party cookie so the backend can gate the
// Google Ads Offline Conversion Import and the Meta Conversions API (only
// `granted` gets sent). Read server-side by StoreQueryParametersInSession.
const writeAdConsentCookie = (hasStatistics) => {
    document.cookie = 'sst_ad_consent=' + (hasStatistics ? 'granted' : 'denied') +
        ';max-age=7776000;path=/;secure;samesite=Lax';
};

// cookie-though keeps the banner choice for a year but only reports it when the
// banner is saved, so mirror it on every page load: otherwise a returning visitor
// loses this cookie after 90 days while the banner stays hidden. Without a valid
// choice (never answered, or the policies changed) there is no consent.
const storedPreferences = getCookiePreferences();

if (storedPreferences.isCustomised) {
    writeAdConsentCookie(hasStatisticsConsent(storedPreferences));
} else {
    document.cookie = 'sst_ad_consent=;max-age=0;path=/;secure;samesite=Lax';
}

onPreferencesChanged((preferences) => {
    window.dataLayer.push({ 'event': 'preferences_changed' });

    const hasStatistics = hasStatisticsConsent(preferences);

    const consentMode = {
        'analytics_storage': hasStatistics ? 'granted' : 'denied',
        'ad_storage': hasStatistics ? 'granted' : 'denied',
        'ad_user_data': hasStatistics ? 'granted' : 'denied',
        'ad_personalization': hasStatistics ? 'granted' : 'denied',
    };

    gtag('consent', 'update', consentMode);
    localStorage.setItem('consentMode', JSON.stringify(consentMode));

    writeAdConsentCookie(hasStatistics);
});

let changeCookiePref = document.getElementsByClassName('js-change-prefs')[0];

changeCookiePref.addEventListener('click', (e) => {
    e.preventDefault();
    showCookieThough();
});

const overwriteCSS = () => {
    const cookieThough = document.querySelector('.cookie-though');
    const [declineButton, acceptButton] = cookieThough.shadowRoot.querySelectorAll('.ct-button');

    declineButton.remove();
};


window.focusTrap = focusTrap;
window.parents = (el, selector) => {
    const parents = [];
    while ((el = el.parentNode) && el !== document) {
    if (!selector || el.matches(selector)) parents.unshift(el);
    }
    return parents;
}
const lightbox = new PhotoSwipeLightbox({
    gallery: '.js-gallery',
    children: 'a.js-pswp',
    pswpModule: () => import('photoswipe')
});
lightbox.init();
document.addEventListener('click', (event) => {
    let el;
    if (event.target.matches('[data-modal-trigger]')) {
        el = event.target;
    } else {
        el = parents(event.target, '[data-modal-trigger]')[0] || null;
    }
    if (el && el.getAttribute('data-modal-trigger')) {
        document.dispatchEvent(new CustomEvent('modal:open', {
            detail: {
                id: el.getAttribute('data-modal-trigger'),
            }
        }));
    }
});
let lastScrollTop = 0;
const searchElement = document.querySelector('.js-searchelement');
const headerElement = document.querySelector('.js-header');
var headerScrollCallback = function () {
    if (headerElement){
        // detects new state and compares it with the new one
        var st = window.scrollY || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (!document.documentElement.classList.contains('is-locked')) {
            if (st < lastScrollTop) {
                headerElement.classList.remove('is-scrolled');
                searchElement.classList.remove('is-scrolled');
            } else {
                if (st > 120) {
                    headerElement.classList.add('is-scrolled');
                    searchElement.classList.add('is-scrolled');
                    lastScrollTop = st;
                }
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
};
//window.addEventListener('scroll', throttle(headerScrollCallback, 700, { leading: true, trailing: true }));
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-thumb').forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            let bigimageurl = item.dataset.bigimageurl;
            let bigimage = document.querySelectorAll('.js-bigimage')[0];
            let bigimageTrigger = document.querySelectorAll('.js-bigimage-trigger')[0];
            bigimage.setAttribute('src', bigimageurl);
            bigimageTrigger.setAttribute('data-index', item.dataset.index);
        });
    });
    // de popup pas tonen nadat de cookiebanner beantwoord is, anders verschijnen ze samen
    var defaultPopup = document.querySelector("#popupModal .c-popup");
    if(defaultPopup){
        let popupOpened = false;
        const openPopup = () => {
            if (popupOpened) return;
            popupOpened = true;
            setTimeout(() => document.dispatchEvent(new CustomEvent('popup:open')), 400);
        };
        if (getCookiePreferences().isCustomised) {
            openPopup();
        } else {
            onPreferencesChanged(openPopup);
        }
    }
    document.querySelectorAll('.js-bigimage-trigger').forEach((item) => {
        item.addEventListener('click', (event) => {
            let index = item.dataset.index;
            let pswpitemtoclick = document.querySelector(`[data-pswp-index="${index}"]`);
            pswpitemtoclick.click();
        });
    });
    document.querySelectorAll('.js-showmoreimagesclick').forEach((item) => {
        item.addEventListener('click', (event) => {
            let index = item.dataset.index;
            let pswpitemtoclick = document.querySelector(`[data-pswp-index="${index}"]`);
            pswpitemtoclick.click();
        });
    });
}, false);

syncHeight();

function syncHeight() {

    let root = document.documentElement;
    /*
    document.documentElement.style.setProperty(
        '--window-inner-height',
        `${window.innerHeight}px`
    );
    let osk = window.innerHeight - window.visualViewport.height;
    document.documentElement.style.setProperty(
        '--osk-height',
        `${osk}px`
    );
    let searchbox = document.querySelector('.c-autocomplete__container');
    if(searchbox){
        if(osk > 0){
            searchbox.style.paddingBottom = osk + "px";
        }
        //searchbox.style.maxHeight = window.visualViewport.height+"px";
        //searchbox.style.height = window.visualViewport.height + "px";
    }
    */
    let header = document.querySelector('.c-header');
    if (header) {
        let headerHeight = header.offsetHeight + 1;
        root.style.setProperty('--header-height', "-" + headerHeight + "px");
    }

    let searchbox = document.querySelector('.c-header__searchcontainer');
    if(searchbox){
        let osk = window.innerHeight - window.visualViewport.height;
        searchbox.style.bottom = osk+"px";
    }
}
window.visualViewport.addEventListener('resize', syncHeight);
overwriteCSS();
